import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class HarponTile extends PIXI.Container {

  constructor(rowIndex, colIndex) {
    super();

    this.rowIndex = rowIndex;
    this.colIndex = colIndex;

    this.dimension = {width: 286, height: 156};

    this.testCounts = 0;
    this.isDisabled = false;
    this.isValidMove = false;
    this.shown = false;

    this.maskTile = null;
  }

  build() {
    // The background is used to set a dimension for the container but will remain invisible
    this.background = new PIXI.Graphics().rect(0, 0, this.dimension.width, this.dimension.height).fill(0x00FF00);
    this.background.alpha = 0.0;
    this.addChild(this.background);

    // In the json file you can set to show or hide the cell coords, useful to create new games easily
    if (app.game.data.show_tiles_coords) {
      this.text = new PIXI.Text({text: "[" + this.rowIndex + "," + this.colIndex + "]"});
      this.text.anchor.set(0.5);
      this.text.position.set(147, 80);
      this.addChild(this.text);
    }
  }

  test() {
    // To be overwritten in child
  }

  hit() {
    // To be overwritten in child if needed
    const shouldEndGame = false;
    return shouldEndGame;
  }

  show() {
    // To be overwritten in child if needed
  }

  validate() {
    return this.isValidMove;
  }

  getCenterPos() {
    return {x: this.position.x + (this.dimension.width / 2), y: this.position.y + (this.dimension.height / 2)};
  }

  isLessThanTwoCellsFromPlayer() {
    // We need to keep in mind that we are in a hexagon like grid but the grid is offset too so the math is kinda weird
    // And because of the offset the rule is different if we are on an odd or even column
    if (this.colIndex % 2 == 0) {
      if (
        (this.rowIndex - app.game.player.currentTile.rowIndex == 2) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 1) ||
        (Math.abs(this.rowIndex - app.game.player.currentTile.rowIndex) <= 1) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 2) ||
        (this.rowIndex - app.game.player.currentTile.rowIndex == -2) && (this.colIndex - app.game.player.currentTile.colIndex == 0)
      ) {
        return true;
      }
    } else {
      if (
        (this.rowIndex - app.game.player.currentTile.rowIndex == 2) && (this.colIndex - app.game.player.currentTile.colIndex == 0) ||
        (Math.abs(this.rowIndex - app.game.player.currentTile.rowIndex) <= 1) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 2) ||
        (this.rowIndex - app.game.player.currentTile.rowIndex == -2) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 1)
      ) {
        return true;
      }
    }

    return false;
  }


  isLessThanOneCellsFromPlayer() {
    // We need to keep in mind that we are in a hexagon like grid but the grid is offset too so the math is kinda weird
    // And because of the offset the rule is different if we are on an odd or even column
    if (this.colIndex % 2 == 0) {
      if (
        (this.rowIndex - app.game.player.currentTile.rowIndex == 1) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 1) || // above, left, center and right
        (this.rowIndex == app.game.player.currentTile.rowIndex) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 1) || // same line, left, right on top (would never happen, or right
        (this.rowIndex - app.game.player.currentTile.rowIndex == -1) && (this.colIndex == app.game.player.currentTile.colIndex) // under, only same col
      ) {
        return true;
      }
    } else {
      if (
        (this.rowIndex - app.game.player.currentTile.rowIndex == 1) && (this.colIndex == app.game.player.currentTile.colIndex) || // above,  only same col
        (this.rowIndex == app.game.player.currentTile.rowIndex) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 1) || // same line, left, right on top (would never happen, or right
        (this.rowIndex - app.game.player.currentTile.rowIndex == -1) && (Math.abs(this.colIndex - app.game.player.currentTile.colIndex) <= 1) // under, left, center and right
      ) {
        return true;
      }
    }

    return false;
  }

  playerIsOnTile() {
    return app.game.player.currentTile == this;
  }

  endOfTurnAction() {
    // To be overwritten in child if needed
  }

  // Technically no reset is needed as tiles are destroyed completely on reset
  reset() {
  }


}
